/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const PlantPotBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5.202 5c.267 1.148.764 1.771 1.279 2.15C7.23 7.7 8.38 8 10 8h.735c-.195-.679-.487-1.251-.846-1.698C9.258 5.515 8.335 5 7 5H5.202ZM7 3c2.92 0 4.853 1.789 5.623 4.33C13.788 5.9 15.48 5 17.363 5h2.629c.552 0 1.005.45.96 1-.356 4.274-3.027 6-6.278 6H13v1h6.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H18v4a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3v-4H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11v-3h-1C6.38 10 3.4 8.696 3.037 4c-.042-.551.41-1 .963-1h3Zm7.675 7h-1.317c.699-1.834 2.322-3 4.006-3h1.41c-.255 1.027-.702 1.675-1.182 2.089-.663.572-1.633.911-2.917.911ZM8 15h8v4a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4Z" /></svg>);
const PlantPot = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={PlantPotBase} {...rest} ref={ref} />);
export default PlantPot;